// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoHomeFilledSvg from "@fishx/icons-svg/es/asn/PtoHomeFilled";
import FishxIcon from '../components/FishxIcon';

var PtoHomeFilled = function PtoHomeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoHomeFilledSvg
  }));
};

PtoHomeFilled.displayName = 'PtoHomeFilled';
export default React.forwardRef(PtoHomeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoHomeFilled.js
// module id = 3904
// module chunks = 0